import {registerGraph, mergeGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('dashboardGraph', dashboardGraph);

/* @ngInject */
function dashboardGraph(GraphService, defaultGraph) {
    const GraphColors = GraphService.colors;
    return mergeGraph(defaultGraph(), {
        options: {
            colors: [GraphColors.lightOrange],
            chart: {
                type: 'area',
                marginTop: 10,
                marginLeft: 0,
                marginRight: 0,
                marginBottom: 0,
                zoomType: 'none',
            },

            lang: {
                noData: false
            },
            title: {
                text: undefined
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                area: {
                    fillOpacity: 0.2,
                    dataLabels: {
                        enabled: false
                    },
                },
                series: {
                    marker: {
                        enabled: false
                    }
                }
            }
        },
        xAxis: {
            visible: false,
            minPadding:0,
            maxPadding:0
        },
        yAxis: {
            visible: false
        },
        size: {
            height: null
        },
        series: [
            {
                data: [],
                lineWidth: 1
            }
        ]
    });
}
